import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetAssessmentAmount = async (requestID) => {

  const accesstoken = getToken();
  if (accesstoken) {
    try {
        const queryParams = new URLSearchParams({
            workReqID: 0,
            entityID: requestID
        }).toString();
      const response = await fetch(`${dev_baseUrl}/WorkRequirement/get?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
        
      if (response.ok && !data.isError) {   
        return data;
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};